import { render, staticRenderFns } from "./gps.vue?vue&type=template&id=08229762&scoped=true&"
import script from "./gps.vue?vue&type=script&lang=js&"
export * from "./gps.vue?vue&type=script&lang=js&"
import style0 from "./gps.vue?vue&type=style&index=0&id=08229762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08229762",
  null
  
)

export default component.exports